
$("#prd_slider").slick({
  infinite: false,
  slidesToShow: 4,
  arrow: true,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 481,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
})
  .on('afterChange', function(event, slick, currentSlide, nextSlide){
  var totalSlides = slick.slideCount;
  var currentSlideIndex = slick.currentSlide;
  var progressPercentage = (currentSlideIndex / (totalSlides - slick.options.slidesToShow)) * 100;
  $('.progress-bar').css('width', progressPercentage + '%');
});

$(".prev-btn").click(function () {
  $("#prd_slider").slick("slickPrev");
});

$(".next-btn").click(function () {
  $("#prd_slider").slick("slickNext");
});


//POPULAR PRODUCT
let swiper = new Swiper("#popular_prd_slider", {
  slidesPerView: "4",
  spaceBetween: 30,
  pagination: {
    el: ".swiper-pagination",
    type: "progressbar"
  },
  breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 15,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1025: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      },
  navigation: {
    prevEl: ".swiper-button-prev",
    nextEl: ".swiper-button-next"
  }
});

  $("#banner-slider").slick({
    infinite: true,
    dots: true,
    arrow:true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: '<button type="button" class="slick-prev"><svg width="7" height="13" viewBox="0 0 7 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.344546 7.3612C0.122886 7.12968 0 6.82505 0 6.5001C0 6.17272 0.122886 5.86646 0.344546 5.63737L5.65895 0.237615C5.96617 -0.0792051 6.46238 -0.0792051 6.76959 0.237615C7.0768 0.554436 7.0768 1.06947 6.76959 1.38548L1.73284 6.5001L6.76959 11.6131C7.0768 11.9299 7.0768 12.445 6.76959 12.7626C6.46238 13.0794 5.96617 13.0794 5.65895 12.761L0.344546 7.36202V7.3612Z" fill="white"/></svg></button>',
    nextArrow: '<button type="button" class="slick-next"><svg width="7" height="13" viewBox="0 0 7 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.65545 7.3612C6.87711 7.12968 7 6.82505 7 6.5001C7 6.17272 6.87711 5.86646 6.65545 5.63737L1.34105 0.237615C1.03383 -0.0792051 0.537624 -0.0792051 0.230411 0.237615C-0.0768032 0.554436 -0.0768032 1.06947 0.230411 1.38548L5.26716 6.5001L0.230411 11.6131C-0.0768032 11.9299 -0.0768032 12.445 0.230411 12.7626C0.537624 13.0794 1.03383 13.0794 1.34105 12.761L6.65545 7.36202V7.3612Z" fill="white"/></svg></button>',
  });

$(document).ready(function () {
    // Ensure #prd_slider is initialized
    if ($('#prd_slider').hasClass('slick-initialized')) {
        var totalSlides = $('#prd_slider').slick('getSlick').slideCount;
        var slidesToShow = $('#prd_slider').slick('getSlick').options.slidesToShow;
        var progressPercentage = (0 / (totalSlides - slidesToShow)) * 100;
        $('.progress-bar').css('width', progressPercentage + '%');
    }

    // Ensure #popular_prd_slider is initialized before accessing Slick properties
    $('#popular_prd_slider').on('init', function (event, slick) {
        var totalSlides = slick.slideCount;
        var slidesToShow = slick.options.slidesToShow;
        var progressPercentage = (0 / (totalSlides - slidesToShow)) * 100;
        $('.progress-bar-pop').css('width', progressPercentage + '%');
    });

    // If #popular_prd_slider is already initialized, manually trigger the function
    if ($('#popular_prd_slider').hasClass('slick-initialized')) {
        var slickInstance = $('#popular_prd_slider').slick('getSlick');
        var totalSlides = slickInstance.slideCount;
        var slidesToShow = slickInstance.options.slidesToShow;
        var progressPercentage = (0 / (totalSlides - slidesToShow)) * 100;
        $('.progress-bar-pop').css('width', progressPercentage + '%');
    }
});
